import React, {  useEffect, useState, useRef } from 'react';
//import './navbar.css';
//import { Link } from "react-router-dom"
import GMap from './Maps_x1_pagina_core';
import { Button, Form } from 'react-bootstrap';
import { BiMapPin } from 'react-icons/bi';
import JSONPretty from 'react-json-pretty';
import axios from "axios";


const GOOGLE_MAP_API_KEY = 'AIzaSyBQ-cYUloNXViXO-th1lYveA1iZ2RuStjo';
var JSONPrettyMon = require('react-json-pretty/dist/monikai');

const Google_maps = (props) => {
    //    const [somma, calcola_somma] = useState('');
    const [loadMap, setLoadMap] = useState(false);
    const [dati_centrali, SET_daticentrali] = useState({lat: 10.0, lng: 10.0});
    const [markerList, SET_markerList] = useState([]);
    const [lista, SET_lista] = useState([]);

 

    useEffect(() => {
    loadGoogleMapScript(() => {
        setLoadMap(true)
    });
    }, []);


    const loadGoogleMapScript = (callback) => {
        if (typeof window.google === 'object' && typeof window.google.maps === 'object') {
            callback();
        } else {
            const googleMapScript = document.createElement("script");
    // idroslab      
            googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}`;
            window.document.body.appendChild(googleMapScript);
            googleMapScript.addEventListener("load", callback);
        }
    } 

    const centra_immagine = () => {

        var geocoder = new window.google.maps.Geocoder();
        const stringa_indirizzo = props.indirizzo.ditta_indirizzo_via + ' ' + props.indirizzo.ditta_indirizzo_via + ', ' + props.indirizzo.ditta_indirizzo_citta
        geocoder.geocode({address: stringa_indirizzo}, function(results, status) {
          console.log(results[0].geometry.location.lat() + ' - ' + results[0].geometry.location.lng())
          SET_daticentrali ({lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng()})
          SET_markerList ([{lat: results[0].geometry.location.lat(), 
                           lng: results[0].geometry.location.lng(),
                           icon: 'https://cdn2.iconfinder.com/data/icons/IconsLandVistaMapMarkersIconsDemo/256/MapMarker_Marker_Outside_Chartreuse.png',
                           info: '<div><h2>Info 2</h2><p>Lorem Ipsum is simply dummy text<br/> of the printing and typesetting industry.</p></div>',
                           title: "Title 2" }])
    
          if (status == window.google.maps.GeocoderStatus.OK) {
        //        map.setCenter(results[0].geometry.location);
          }
        })
    }


    const carica_ditte_con_geolocalizzazione = () => {
        console.log('Carica_domande_x_account')
        let end_date = 5
        var utente = 'utente_unico'
        //        https://mydomain.dm/fruit/{"name":"My fruit name", "color":"The color of the fruit"}

        axios.get('/ditte/ditte_carica_quelle_con_geolocalizzazione/' + utente)
            .then((res) => {
                console.log('domande appena fecciate da mongo')
                console.log(res.data)
            }).catch((error) => {
                console.log(error)
            });
    }

    const uploadFiles = async event => {
    }

    const submit = async event => {
    }





    return (
    <>
        <div className="container d-flex flex-column justify-content-center">
            <h4>Sede di stage </h4>
            <Button onClick={() => centra_immagine()}>  <BiMapPin /> Localizzazione tramite indirizzo</Button>
            <Button onClick={() => carica_ditte_con_geolocalizzazione()}>  <BiMapPin /> Carica ditte con geolocalizzazione</Button>
      
            <small><b>Note:</b> Correggere la posizione con un click del mouse </small>
            {!loadMap ? <div>Loading...</div> : <GMap dati_centrali= {dati_centrali} 
                                                        markerList={markerList} 
                                                        SET_markerList={SET_markerList} />}
            <br/>

  
            {(props.account_dati.utente_debug) &&
        
                <JSONPretty data={lista} />
            }                  
            <JSONPretty data={lista} theme={JSONPrettyMon}/>

        </div>

            <div className="d-flex flex-column justify-content-center">

            <Form onSubmit={submit}>
            <Form.Group controlId="formFile" className="mb-3">
                <Form.Label>Seleziona un file pdf da caricare</Form.Label>
                <Form.Control type="file" multiple onChange={(e) => uploadFiles(e)} accept="image/*"/>
            </Form.Group>

            </Form>
        </div>
    </>

    )
}
export default Google_maps;